import * as v from '@badrap/valita'

export const regionSchema = v.union(
  v.literal('af-south-1'),
  v.literal('ap-northeast-1'),
  v.literal('ap-northeast-2'),
  v.literal('ap-southeast-1'),
  v.literal('ap-southeast-2'),
  v.literal('ca-central-1'),
  v.literal('eu-central-1'),
  v.literal('eu-west-2'),
  v.literal('us-east-1'),
  v.literal('us-west-2'),
)

export type Region = v.Infer<typeof regionSchema>

export const regionsWithName: Record<Region, string> = {
  'af-south-1': 'Africa (Cape Town)',
  'ap-northeast-1': 'Asia Pacific (Tokyo)',
  'ap-northeast-2': 'Asia Pacific (Seoul)',
  'ap-southeast-1': 'Asia Pacific (Singapore)',
  'ap-southeast-2': 'Asia Pacific (Sydney)',
  'ca-central-1': 'Canada (Central)',
  'eu-central-1': 'Europe (Frankfurt)',
  'eu-west-2': 'Europe (London)',
  'us-east-1': 'US East (N. Virginia)',
  'us-west-2': 'US West (Oregon)',
}
